import { buildComplexFieldKey } from "@/constants/fieldKeys";
import { FieldV2 } from "@ucl/library";
import { CoreFieldProps } from "@ucl/library/src/components/Fields/types/fieldTypes";

export interface FieldComplexV2Props extends CoreFieldProps {
  complexFieldKey: string;
  complexFieldProps?: Omit<Partial<CoreFieldProps>, "fieldKey">;
}

export const FieldComplexV2 = (props: FieldComplexV2Props) => {
  if (!props.fieldKey) {
    throw new Error("FieldComplexV2: fieldKey is required");
  }

  const fieldProps = !props.complexFieldProps
    ? buildComplexFieldKey(props.fieldKey, props.complexFieldKey)
    : {
        ...props.complexFieldProps,
        fieldKey: buildComplexFieldKey(props.fieldKey, props.complexFieldKey),
      };

  return (
    // If complexFieldKey is a string, use buildComplexFieldKey to build the fieldProps,
    // otherwise, use the complexFieldKey as the fieldProps passing the buildComplexFieldKey to setup the fieldKey property of the fieldProps
    <FieldV2 fieldProps={fieldProps} />
  );
};
